import { useResource } from '@landsbankinn/l16n';
import { useInputValidation, DateInput as UiDateInput } from '@landsbankinn/ui';
import { set } from 'date-fns';
import React from 'react';
import { useAppointmentContext } from '../../../book-appointment/BookAppointment';
import res from './SelectDateAndTime.res';

interface IProps {
  setSelectedTime: React.Dispatch<React.SetStateAction<number | undefined>>;
  availableDates?: Date[];
}

export function DateInput({ setSelectedTime, availableDates }: IProps) {
  const { r } = useResource();
  const { state, dispatch } = useAppointmentContext();

  const [ref, isValid] = useInputValidation(state?.date?.toString(), [
    {
      validation: (value) => value !== undefined,
    },
  ]);

  return (
    <UiDateInput
      isValid={isValid}
      id="appointmentDate"
      variant="noBorder"
      label={r(res.pickDate)}
      labelVariant="aboveInput"
      errorMessageVariant="insideInput"
      inputSize="big"
      includeDates={availableDates}
      value={state.date}
      onChange={(date) => {
        setSelectedTime(undefined);
        dispatch?.({
          type: 'selectDateAndTime',
          date: set(date, { hours: 0, minutes: 0, seconds: 0 }),
        });
      }}
    />
  );
}
